export default __webpack_public_path__ + "static/media/presale_img.babb18cd.png";